import { motion } from "framer-motion";

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="bg-[#050505] px-5 py-24 sm:px-10 sm:py-36"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 lg:grid-cols-[1.4fr_1fr] lg:gap-20">
      <div>
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          className="mb-8 block font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs"
        >
          06 — THE STUDIO
        </motion.span>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-[clamp(2.6rem,6vw,5.5rem)] font-black uppercase leading-[0.9] tracking-tight text-[#F3F3F5]"
        >
          BEHIND JW. EDITS.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-10 max-w-xl text-sm leading-relaxed text-[#8E8E93] sm:text-base"
        >
          JW. EDITS was created by Jeremiah Womack, a young creative who began editing through
          documenting his own life online. After creating Instagram vlogs, social content,
          personal projects, and a digital brand of his own, Jeremiah began applying that same
          eye for pacing, storytelling, and presentation to other people's footage.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="mt-10 max-w-xl font-display text-2xl font-bold uppercase leading-tight tracking-tight text-[#F3F3F5] sm:text-3xl"
        >
          The goal is simple: preserve real moments{" "}
          <span className="text-[#E63946]">without editing the humanity out of them.</span>
        </motion.p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        className="relative self-start"
      >
        <div className="overflow-hidden border border-white/10">
          <img
            src="https://customer-assets-lxgj4vgw.emergentagent.net/job_story-in-motion-7/artifacts/mvypepat_20260409_145327.webp"
            alt="Jeremiah Womack standing on the National Mall, Washington DC"
            className="aspect-[4/5] w-full object-cover opacity-90 transition-all duration-700 hover:opacity-100"
          />
        </div>
        <span className="mt-3 block font-mono text-[10px] uppercase tracking-[0.3em] text-[#3a3a3f]">
          FIG. 01 — JEREMIAH WOMACK, THE EDITOR HIMSELF
        </span>
      </motion.div>
    </div>
  </section>
);
